import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "../assets/css/HomePage.css";

function getLang(pathname) {
  return pathname.startsWith("/bn") ? "bn" : "en";
}

function setMetaTag(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setPropertyTag(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLinkTag(rel, href, attrs = {}) {
  const selector = `link[rel="${rel}"]${attrs.hreflang ? `[hreflang="${attrs.hreflang}"]` : ""}`;
  const existing = document.querySelector(selector);

  // создаём новый тег и жёстко задаём порядок атрибутов
  const link = document.createElement("link");
  link.setAttribute("rel", rel);
  link.setAttribute("href", href);            // <-- href вторым
  if (attrs.hreflang) {
    link.setAttribute("hreflang", attrs.hreflang); // <-- hreflang третьим
  }

  if (existing) {
    existing.replaceWith(link);
  } else {
    document.head.appendChild(link);
  }
}


const NotFound = () => {
  const { pathname } = useLocation();
  const lang = getLang(pathname);

  useEffect(() => {
    const origin = window.location.origin;
    const currentUrl = origin + pathname;

    // -------- <title> + description (EN/BN)
    const title =
      lang === "bn"
        ? "৪০৪ পাওয়া যায়নি | HHBD"
        : "404 Not Found | HHBD";

    const description =
      lang === "bn"
        ? "আপনি যে পৃষ্ঠাটি খুঁজছেন তা নেই। HHBD হোমে ফিরে যান বা শীর্ষ ক্যাসিনো গেমস এক্সপ্লোর করুন।"
        : "The page you're looking for doesn’t exist. Return to HHBD Home or explore top casino games.";

    document.title = title;
    setMetaTag("description", description);

    // -------- robots (noindex 404)
    setMetaTag("robots", "noindex, nofollow");

    // -------- Canonical
    setLinkTag("canonical", currentUrl);
 const twitterImageAlt = lang === "bn" ? 
 "HHBD 404 – পৃষ্ঠাটি খুঁজে পাওয়া যায়নি, তবে ক্যাসিনো হোমপেজে আপনার পরবর্তী বড় জয় অপেক্ষা করছে।" :
  "HHBD 404 – page not found, but your next big win is waiting on the casino homepage.";
 
    // -------- hreflang alternates (между EN 404 и BN 404)
    const en404 = `${origin}/404`;
    const bn404 = `${origin}/bn/404`;
    setLinkTag("alternate", en404, { hreflang: "en" });
    setLinkTag("alternate", bn404, { hreflang: "bn" });
    setLinkTag("alternate", en404, { hreflang: "x-default" });

    // -------- Open Graph
    setPropertyTag("og:title", title);
    setPropertyTag("og:description", description);
    setPropertyTag("og:url", currentUrl);
    setPropertyTag("og:type", "website");
        setPropertyTag("og:image:alt", twitterImageAlt);
    // при наличии изображения можно раскомментировать и указать путь:
    // setPropertyTag("og:image", `${origin}/og/og-404.png`);

    // -------- Twitter Cards
    setMetaTag("twitter:card", "summary");
    setMetaTag("twitter:title", title);
    setMetaTag("twitter:description", description);
        setMetaTag("twitter:image:alt", twitterImageAlt);
    // setMetaTag("twitter:image", `${origin}/og/og-404.png`);

    // -------- JSON-LD (schema.org)
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": title,
      "inLanguage": lang === "bn" ? "bn" : "en",
      "url": currentUrl,
      "isPartOf": {
        "@type": "WebSite",
        "name": "HHBD",
        "url": origin
      },
      "description": description
    };

    let ld = document.getElementById("ld-notfound");
    if (!ld) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "ld-notfound";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(jsonLd);
  }, [lang, pathname]);

  return (
    <section
      className="zHHBD-action"
      style={{ padding: 0, marginTop: "-75px", minHeight: "100vh" }}
    >
      <div className="zHHBD-action__bg">
        <div className="zHHBD-action__chips">
          <span className="zHHBD-action__chip zHHBD-action__chip--1"></span>
          <span className="zHHBD-action__chip zHHBD-action__chip--2"></span>
          <span className="zHHBD-action__chip zHHBD-action__chip--3"></span>
        </div>
        <div className="zHHBD-action__spark zHHBD-action__spark--1"></div>
        <div className="zHHBD-action__spark zHHBD-action__spark--2"></div>
      </div>

      <div
        className="zHHBD-action__container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <div
          className="zHHBD-action__content"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <header className="zHHBD-action__header">
            <div className="noise"></div>
            <div className="overlay"></div>
            <div className="terminal">
              {lang === "bn" ? (
                <>
                  <h1 className="title">
                    উফ! পৃষ্ঠা পাওয়া যায়নি 🕳️{" "}
                    <span className="errorcode">404</span>
                  </h1>
                  <p className="output">
                    মনে হচ্ছে আপনি হারিয়ে গেছেন — চলুন আপনাকে আবার অ্যাকশনে ফিরিয়ে আনি।
                  </p>
                  <p className="output">
                    নিচের যে কোনো সেকশনে যান এবং খেলা চালিয়ে যান 👇
                  </p>
                  <div
                    className="zHHBD-apphero__ctas"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px",
                      justifyContent: "center",
                      marginTop: "25px",
                    }}
                  >
                    <Link
                      to="/bn/"
                      className="zHHBD-apphero__btn zHHBD-apphero__btn--main"
                      title="HHBD হোমপেজে ফিরে যান"
                    >
                      হোমে যান
                    </Link>
                    <Link
                      to="/bn/casino"
                      className="zHHBD-apphero__btn zHHBD-apphero__btn--ghost"
                      title="HHBD–এ ক্যাসিনো গেমস খেলুন"
                    >
                      ক্যাসিনো খেলুন
                    </Link>
                    <Link
                      to="/bn/slots"
                      className="zHHBD-apphero__btn zHHBD-apphero__btn--ghost"
                      title="HHBD–এ স্লটস এক্সপ্লোর করুন"
                    >
                      স্লটস দেখুন
                    </Link>
                  </div>
                  <p className="output">শুভকামনা।</p>
                </>
              ) : (
                <>
                  <h1 className="title">
                    Oops! Page not found 🕳️{" "}
                    <span className="errorcode">404</span>
                  </h1>
                  <p className="output">
                    Seems like you got lost — let’s get you back to the action.
                  </p>
                  <p className="output">
                    Try one of the sections below to get back in the game 👇
                  </p>
                  <div
                    className="zHHBD-apphero__ctas"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px",
                      justifyContent: "center",
                      marginTop: "25px",
                    }}
                  >
                    <Link
                      to="/"
                      className="zHHBD-apphero__btn zHHBD-apphero__btn--main"
                      title="Return to HHBD homepage"
                    >
                      Go Home
                    </Link>
                    <Link
                      to="/casino"
                      className="zHHBD-apphero__btn zHHBD-apphero__btn--ghost"
                      title="Play casino games on HHBD"
                    >
                      Play Casino
                    </Link>
                    <Link
                      to="/slots"
                      className="zHHBD-apphero__btn zHHBD-apphero__btn--ghost"
                      title="Explore slot games at HHBD"
                    >
                      Explore Slots
                    </Link>
                  </div>
                  <p className="output">Good luck.</p>
                </>
              )}
            </div>
          </header>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
